import { useEffect, useRef, useState } from "react";
import ModalGlobal from "../modalGlobalTopbar/ModalGlobalTopbar";
import style from "./ModalUsuarioInfo.module.css";
import { Link } from "react-router-dom";
import { IoMdInformationCircle } from "react-icons/io";
import { RiLogoutBoxRFill } from "react-icons/ri";
import Cookies from "js-cookie";

function ModalUsuarioInfo({ mostrar, aoFechar, botaoRef }) {
  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });
  const [posicaoCalculada, setPosicaoCalculada] = useState(false); // 👈 controle novo

  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      const modalWidth = 205;
      const windowWidth = window.innerWidth;

      const left = Math.min(rect.right - modalWidth, windowWidth - modalWidth - 10);

      setPosicao({
        top: rect.bottom + 5,
        left: left - 2,
      });

      setPosicaoCalculada(true); // 👈 só depois que calcular, libera o render
    }
  };

  useEffect(() => {
    if (mostrar) {
      setPosicaoCalculada(false); // 👈 marca como "não pronto"

      setTimeout(() => {
        calcularPosicao(); // espera um ciclo para o botão renderizar
      }, 0);

      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]);

  const Deslogar = () => {
    Cookies.remove("token", {
      domain: process.env.REACT_APP_DOMINIO,
      path: "/",
    });
    window.location.href = process.env.REACT_APP_SITE_LOGIN;
  };

  return (
    <ModalGlobal mostrar={mostrar} aoFechar={aoFechar} botaoRef={botaoRef}>
      {posicaoCalculada && (
        <div
          ref={modalRef}
          className={style.container_modal}
          style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
        >
          <Link to={"/informacao"} className={style.topbar_item}>
            <IoMdInformationCircle />
            <h3 className={style.texto_link}>Informação</h3>
          </Link>

          <Link onClick={Deslogar} className={style.topbar_item}>
            <RiLogoutBoxRFill />
            <h3 className={style.texto_link}>Sair</h3>
          </Link>
        </div>
      )}
    </ModalGlobal>
  );
}

export default ModalUsuarioInfo;
